










































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { SortableTableHeader } from "../generic-pms-table/SortableTableDirective";
import * as _ from "lodash";
import { DataOptions } from "vuetify";
import { ListModel } from "@/shared/models/listModel";
import DateField from "@/components/misc/DateField.vue";
import SortableHeadersTable from "@/components/generic-pms-table/SortableHeadersTable.vue";
import { PaymentQueryViewModel } from "@/shared/models/payment";
import { formatOrderbyArray } from "@/shared/sortHelperFunctions";
import { saveFile } from "@/shared/saveFile";
import { Action, Getter } from "vuex-class";
import { Currency } from "@/shared/models/currency";
import { CardType } from "@/shared/models/cardType";
import { PaymentMean } from "@/shared/models/paymentMean";
import CreditCardInfoModal from "@/components/credit-card/CreditCardInfoModal.vue";
import NoData from "@/components/misc/NoData.vue";
import ReservationFormPaymentForm from "../reservation-form/ReservationFormPaymentForm.vue";
import { Notification } from "../../store/modules/notifications";
import { PaymentModel } from "../reservation-form/types";
import { JwtClaims } from "@/store/modules/auth";
import { BusinessUnit } from "@/shared/models/businessUnit";
import { CashRegisterModel } from "@/shared/models/cashRegister";
import FinancialDocumentModalForm from "./FinancialDocumentModalForm.vue";
import { FinancialDocumentTypesEnum } from "@/shared/models/enums.type";
import InvoiceRoutingModal from "@/components/finances/InvoiceRoutingModal/InvoiceRoutingModal.vue";
import RequireRole from "@/components/misc/RequireRole.vue";
import { userCanCreateFinancialDocuments } from "@/shared/roles";
import { CreateAdvanceInvoiceForPaymentsResultModel } from "./FinancialDocumentFormParts/models";

@Component({
  components: {
    SortableHeadersTable,
    DateField,
    CreditCardInfoModal,
    ReservationFormPaymentForm,
    NoData,
    FinancialDocumentModalForm,
    InvoiceRoutingModal,
    RequireRole,
  },
})
export default class PaymentsTable extends Vue {
  settingsOpen = false;
  loading = true;

  @Prop({ default: "page" }) type?: "page" | "reservationmodal";
  @Prop() reservationId?: number | null;
  @Prop() reservationStatusId?: number | null;

  @Watch("reservationId", { immediate: true })
  reservationIdChanged(fresh: number | null) {
    this.filters.reservationId = fresh;
  }

  @Prop() hasCreditCard?: boolean;
  @Prop() reservationCustomerId?: number | null;
  @Prop() reservationPaymentMeans?: number | null;

  messages: string[] = [];

  // prettier-ignore
  @Action("codebooks/refreshCurrencies")
  refreshCurrencies?: () => Promise<void>;
  @Getter("codebooks/currencies") currencies?: Currency[];

  // prettier-ignore
  @Action("codebooks/refreshCardTypes")
  refreshCardTypes?: () => Promise<void>;
  @Getter("codebooks/cardTypes") cardTypes?: CardType[];

  // prettier-ignore
  @Action("codebooks/refreshPaymentMeans")
  refreshPaymentMeans?: () => Promise<void>;
  @Getter("codebooks/paymentMeans") paymentMeans?: PaymentMean[];

  @Getter("appParams/cashRegisterFeatureFlag")
  cashRegisterFeature?: boolean;

  @Getter("businessUnit/activeBusinessUnit") activeBusinessUnit?: BusinessUnit;
  @Getter("cashRegister/activeCashRegister")
  activeCashRegister?: CashRegisterModel;
  financialDocumentTypesEnum = FinancialDocumentTypesEnum;

  get canCreateFinDocs() {
    return userCanCreateFinancialDocuments()(this.claims);
  }

  async created() {
    const promises = [];

    if ((this.currencies?.length ?? 0) === 0 && this.refreshCurrencies) {
      promises.push(this.refreshCurrencies());
    }

    if ((this.cardTypes?.length ?? 0) === 0 && this.refreshCardTypes) {
      promises.push(this.refreshCardTypes());
    }

    if ((this.paymentMeans?.length ?? 0) === 0 && this.refreshPaymentMeans) {
      promises.push(this.refreshPaymentMeans());
    }

    await Promise.all(promises);
  }

  getCurrencyCode(currencyId: number) {
    return this.currencies?.find((x) => x.id == currencyId)?.isoCode;
  }

  _loadedSettings = false;
  get loadedSettings() {
    return this.$data._loadedSettings;
  }
  set loadedSettings(val) {
    if (!this.$data._loadedSettings) {
      this.$data._loadedSettings = true;
      this.load();
    }
  }

  options: DataOptions = {
    page: 1,
    itemsPerPage: 15,
    sortBy: ["id"],
    sortDesc: [true],
    groupBy: [],
    groupDesc: [],
    multiSort: false,
    mustSort: true,
  };

  @Watch("options", { deep: true })
  watchOptions(fresh: DataOptions, old: DataOptions) {
    if (!_.isEqual(fresh, old)) {
      this.load();
    }
  }

  headers: SortableTableHeader[] = [];

  @Getter("auth/claims") claims?: JwtClaims;
  @Watch("claims.roles", { immediate: true })
  rolesWatch() {
    this.headers = [
      {
        text: "VPayment.paymentDate",
        value: "paymentDate",
        active: true,
        default: false,
        class: "resize-header",
        exportHeaders: ["paymentDate"],
      },
      {
        text: "VPayment.amount",
        value: "amount",
        active: true,
        default: false,
        class: "resize-header",
        exportHeaders: ["amount"],
      },
      {
        text: "VPayment.paymentMeans",
        value: "paymentMeansId",
        active: true,
        default: false,
        class: "resize-header",
        exportHeaders: ["paymentMeansId"],
      },
      {
        text: "VPayment.cardType",
        value: "cardType",
        active: true,
        default: false,
        class: "resize-header",
        exportHeaders: ["cardType"],
      },
      {
        text: "VPayment.onlinePayment",
        value: "isOnlinePayment",
        active: true,
        default: false,
        class: "resize-header",
        exportHeaders: ["onlinePayment"],
      },
      {
        text: "VPayment.RemainingAmount",
        value: "remainingAmount",
        active: true,
        default: false,
        class: "resize-header",
        exportHeaders: ["RemainingAmount"],
      },
      // TODO: we should start removing the cash register feature flag, everyone should be using it anyway
      ...(this.cashRegisterFeature
        ? [
            {
              text: "VPayment.referenceDocumentInternalIdentifier",
              value: "referenceDocumentInternalIdentifier",
              active: true,
              default: false,
              class: "resize-header",
              sortable: false,
              exportHeaders: ["referenceDocumentInternalIdentifier"],
            },
          ]
        : [
            {
              text: "VPayment.referenceDocument",
              value: "referenceDocument",
              active: true,
              default: false,
              class: "resize-header",
              sortable: false,
              exportHeaders: ["referenceDocument"],
            },
          ]),
      {
        text: "Actions",
        value: "actions",
        sortable: false,
        active: true,
        default: true,
        class: "resize-header",
        exportHeaders: [],
      },
    ];
  }

  filters = {
    paymentDate: "",
    paymentMeansId: null as number | null,
    cardTypeId: null as number | null,
    referenceDocument: "",
    referenceDocumentInternalIdentifier: "",
    reservationId: null as number | null,
    isOnlinePayment: false as boolean | false,
  };

  @Watch("filters", { deep: true })
  watchFilters(val: any, old: any) {
    if (_.isEqual(val, old)) {
      this.options.page = 1;
      this.debouncedLoad();
    }
  }

  list: ListModel<PaymentQueryViewModel> = {
    count: 0,
    result: [],
  };

  debouncedLoad = _.debounce(this.load, 500);

  async load(): Promise<ListModel<PaymentQueryViewModel>> {
    if (!this.loadedSettings) {
      return Promise.resolve({ count: 0, result: [] });
    }

    this.loading = true;
    return this.axios
      .get<ListModel<PaymentQueryViewModel>>(`/payments`, {
        params: this.queryParams,
      })
      .then((res) => {
        this.list = res.data;
        return this.list;
      })
      .finally(() => (this.loading = false));
  }

  get queryParams() {
    return {
      $skip: this.options.itemsPerPage * (this.options.page - 1),
      $top: this.options.itemsPerPage,
      $orderby: formatOrderbyArray(
        this.options.sortBy,
        this.options.sortDesc.map((x) => !x)
      ),
      $count: true,
      ...this.filters,
    };
  }

  exportToExcel() {
    this.loading = true;

    return this.axios
      .get("payments/export/excel", {
        params: {
          ...this.queryParams,
          $skip: 0,
          $top: null,
          headers: this.headers
            .filter((h) => h.active)
            .flatMap((h) => h.exportHeaders)
            .join(","),
        },
        responseType: "blob",
      })
      .then((res) => {
        const groups = /filename=(?<filename>[^;]+);/.exec(
          res.headers["content-disposition"]
        )?.groups;
        saveFile(res.data, groups?.filename ?? "Payments.xlsx");
      })
      .finally(() => {
        this.loading = false;
      });
  }

  paymentFormOpen = false;
  paymentModel = new PaymentModel();
  paymentFormPaymentId: number | null = null;

  openItemDetails(item: PaymentQueryViewModel) {
    this.paymentFormPaymentId = item.id;
    this.paymentFormOpen = true;
  }

  invoiceRoutingReservationId: number | null = null;
  invoiceRoutingCustomerId: number | null = null;
  invoiceRoutingCustomerName = "";
  invoiceRoutingCustomerOib = "";
  invoiceRoutingPaymentMeansId: number | null = null;
  invoiceRoutingCardTypeId: number | null = null;
  invoiceRoutingOpen = false;
  invoiceEditingOpen = false;
  financialDocumentId: number | null = null;
  financialDocumentModalOpen = false;
  autoDeleteDocument = false;

  async generateAdvanceInvoice(paymentId: number, reservationId: number) {
    if (!this.activeBusinessUnit || !this.activeCashRegister) {
      this.$store.dispatch("showNotification", {
        color: "success",
        message:
          "FinancialDocument.CreationValidation.MustSelectBusinessUnitAndCashRegister",
        timeout: 5000,
        localize: true,
      } as Notification);
      return;
    }
    const invoiceRoutingCheck = await Vue.axios.post<any>(
      "financialDocuments/CheckIfPaymentsNeedInvoiceRouting",
      {
        paymentId: paymentId,
      }
    );
    if (invoiceRoutingCheck.data.isRoutingNeeded) {
      this.invoiceRoutingReservationId = invoiceRoutingCheck.data.reservationId;
      this.invoiceRoutingCustomerId = invoiceRoutingCheck.data.customerId;
      this.invoiceRoutingCustomerName = invoiceRoutingCheck.data.customerName;
      this.invoiceRoutingCustomerOib = invoiceRoutingCheck.data.customerOib;
      this.invoiceRoutingPaymentMeansId =
        invoiceRoutingCheck.data.paymentMeansId;
      this.invoiceRoutingCardTypeId = invoiceRoutingCheck.data.cardTypeId;
      this.invoiceRoutingOpen = true;
    }
    // create a document,lock it and pay
    else {
      this.$store.dispatch("showNotification", {
        color: "success",
        message: this.$t("Payments.GeneratingPaidInvoice"),
        timeout: 5000,
        localize: true,
      });

      this.loading = true;
      await Vue.axios
        .post<CreateAdvanceInvoiceForPaymentsResultModel>(
          "financialDocuments/CreateAdvanceInvoiceForPayments",
          {
            paymentId: paymentId,
            reservationId: reservationId,
            businessUnitId: this.activeBusinessUnit.id,
            cashRegisterId: this.activeCashRegister.id,
            showOwnerDetails: true,
            defaultToPropertyBusinessUnit: true,
          }
        )
        .then((res) => {
          this.$store.dispatch("showNotification", {
            color: "success",
            message: this.$t("Payment.SuccessfullyCreatedPaidInvoice"),
            timeout: 5000,
            localize: true,
          });
          if (res.data.locked)
            this.messages.push("FinancialDocument.LockSuccess");
          if (res.data.fiscalized)
            this.messages.push("FinancialDocument.FiscalizationSuccess");
          if (res.data.paid) {
            this.messages.push("FinancialDocument.MarkAsPaidSuccess");
          }
          if (!res.data.pdfGenerated) {
            this.$store.dispatch("showNotification", {
              color: "error",
              message: this.$t("FinancialDocument.PdfNotGenerated"),
              timeout: 5000,
            } as Notification);
          }
        })
        .catch(() => {
          this.$store.dispatch("showNotification", {
            color: "error",
            message: this.$t("PrepaymentDirectCharge.Error.Unknown"),
            timeout: 5000,
          } as Notification);
        })
        .finally(() => {
          this.loading = false;
          this.showMessages();
          this.$emit("saved");
          this.$emit("refresh");
        });
    }
  }

  showMessages() {
    this.loading = false;
    const formatSuccessMessages = (x: string[]) =>
      x
        .map((h) => this.$t(h).toString())
        .map((th) => (th.endsWith(".") ? th : th + "."))
        .join(" ");

    const fiscalizationFailed = this.messages.findIndex(
      (x) => x === "FinancialDocument.FiscalizationFailed"
    );

    if (fiscalizationFailed !== -1) {
      this.messages.splice(fiscalizationFailed, 1);
      this.$store.dispatch("showNotification", {
        color: "error",
        message: this.$t("FinancialDocument.FiscalizationFailed"),
        timeout: 5000,
      });
    }

    const ownersInvoicesCreationFailed = this.messages.findIndex(
      (x) => x === "FinancialDocument.CreateOwnersInvoices.NoInvoicesCreated"
    );
    if (ownersInvoicesCreationFailed !== -1) {
      this.messages.splice(ownersInvoicesCreationFailed, 1);
      this.$store.dispatch("showNotification", {
        color: "error",
        message: this.$t(
          "FinancialDocument.CreateOwnersInvoices.NoInvoicesCreated"
        ),
        timeout: 5000,
      });
    }

    const ownersInvoicesLockingFailed = this.messages.findIndex(
      (x) => x === "FinancialDocument.CreateOwnersInvoices.LockingFailed"
    );
    if (ownersInvoicesLockingFailed !== -1) {
      this.messages.splice(ownersInvoicesLockingFailed, 1);
      this.$store.dispatch("showNotification", {
        color: "error",
        message: this.$t(
          "FinancialDocument.CreateOwnersInvoices.LockingFailed"
        ),
        timeout: 5000,
      });
    }

    if (this.messages.length > 0) {
      this.$store.dispatch("showNotification", {
        color: "success",
        message: formatSuccessMessages(this.messages),
        timeout: 5000,
      });
    }

    this.messages = [];

    this.$emit("refresh");
  }

  rowDoubleClick(e: MouseEvent, { item }: { item: PaymentQueryViewModel }) {
    this.openItemDetails(item);
  }

  newPayment() {
    this.paymentFormPaymentId = null;
    this.paymentModel = new PaymentModel();
    this.paymentModel.customerId = this.reservationCustomerId || null;
    this.paymentModel.paymentMeansId = this.reservationPaymentMeans || null;
    this.paymentModel.financialDocumentId = null;
    this.paymentModel.financialDocumentStatusId = null;
    this.paymentModel.reservationId = this.reservationId ?? null;
    this.paymentFormOpen = true;
  }

  deleteItem(item: PaymentQueryViewModel) {
    const referencedDocuments =
      item.financialDocuments && item.financialDocuments.length > 0
        ? this.cashRegisterFeature
          ? item.financialDocuments.map(
              (fd) =>
                fd.referenceDocumentInternalIdentifier +
                (fd.assignedAmount !== item.amount
                  ? ` (${this.$n(fd.assignedAmount, {
                      style: "currency",
                      currency: item.currencyCode,
                      currencyDisplay: "code",
                    })})`
                  : "")
            )
          : item.financialDocuments.map(
              (fd) =>
                fd.referenceDocument +
                (fd.assignedAmount !== item.amount
                  ? ` (${this.$n(fd.assignedAmount, {
                      style: "currency",
                      currency: item.currencyCode,
                      currencyDisplay: "code",
                    })})`
                  : "")
            )
        : [];

    this.$store.dispatch("showNotification", {
      id: item.id,
      color: "warning",
      message: this.$t("Payment.DeleteConfirmation"),
      submessages:
        referencedDocuments.length > 0
          ? [
              this.$t("Payment.DeleteConfirmation.FinDocs") + ":",
              ...referencedDocuments,
            ]
          : [],
      actions: [
        {
          text: this.$t("Delete"),
          fun: () => {
            this.deleteItemConfirm(item);
            return true;
          },
        },
        {
          text: this.$t("Cancel"),
          fun: () => {
            return true;
          },
        },
      ],
      timeout: 30000,
    } as Notification);
  }

  deleteItemConfirm(item: PaymentQueryViewModel) {
    Vue.axios
      .delete(`/payments/${item.id}`)
      .then((res) => {
        this.$store.dispatch("showNotification", {
          color: "success",
          message: this.$t("Payment.DeleteSuccess"),
          timeout: 5000,
        } as Notification);
        if (res.data == true) {
          this.$store.dispatch("showNotification", {
            color: "success",
            message: this.$t("Payment.ReferenceDocumentStatusToLocked", {
              // value: this.cashRegisterFeature
              //   ? referenceDocumentInternalIdentifier
              //   : referenceDocument,
            }),
            timeout: 10000,
          } as Notification);
        }
      })
      .finally(() => {
        this.load();
        this.$emit("saved");
      });
  }
}
